import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { SECTOR_LIST, SECTOR_COLORS } from "@/data/sectorConfig";

const colorMap = {
  emerald: {
    bg: "bg-emerald-50",
    border: "hover:border-emerald-400",
    icon: "bg-emerald-100 text-emerald-600",
    tag: "text-emerald-700",
    arrow: "text-emerald-600 group-hover:text-emerald-700",
  },
  blue: {
    bg: "bg-blue-50",
    border: "hover:border-blue-400",
    icon: "bg-blue-100 text-blue-600",
    tag: "text-blue-700",
    arrow: "text-blue-600 group-hover:text-blue-700",
  },
  amber: {
    bg: "bg-amber-50",
    border: "hover:border-amber-400",
    icon: "bg-amber-100 text-amber-600",
    tag: "text-amber-700",
    arrow: "text-amber-600 group-hover:text-amber-700",
  },
  violet: {
    bg: "bg-violet-50",
    border: "hover:border-violet-400",
    icon: "bg-violet-100 text-violet-600",
    tag: "text-violet-700",
    arrow: "text-violet-600 group-hover:text-violet-700",
  },
};

export const SectorsHighlight = () => {
  const navigate = useNavigate();

  return (
    <section className="py-20 sm:py-28 bg-white" data-testid="sectors-highlight-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-left max-w-xl mb-14">
          <span className="text-emerald-600 font-semibold text-sm uppercase tracking-wide">
            Le Nostre Soluzioni
          </span>
          <h2
            className="mt-3 text-3xl sm:text-4xl font-bold text-slate-900 tracking-tight"
            style={{ fontFamily: "Outfit, sans-serif" }}
            data-testid="sectors-title"
          >
            Energia verde per ogni esigenza
          </h2>
          <p className="mt-4 text-slate-500 text-base sm:text-lg">
            Soluzioni fotovoltaiche personalizzate per privati e PMI.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {SECTOR_LIST.map((sector, i) => {
            const colors = colorMap[sector.color];
            const Icon = sector.icon;
            return (
              <button
                key={sector.id}
                onClick={() => navigate(`/${sector.id}`)}
                className={`group text-left bg-white rounded-2xl border border-slate-100 ${colors.border} p-6 transition-all duration-300 hover:shadow-xl hover:-translate-y-1 animate-fade-in-up cursor-pointer`}
                style={{ animationDelay: `${i * 100}ms` }}
                data-testid={`sector-card-${sector.id}`}
              >
                <div className={`w-12 h-12 rounded-xl ${colors.icon} flex items-center justify-center mb-5`}>
                  <Icon className="w-6 h-6" strokeWidth={1.5} />
                </div>
                <h3
                  className="text-lg font-bold text-slate-900 mb-2"
                  style={{ fontFamily: "Outfit, sans-serif" }}
                >
                  {sector.label}
                </h3>
                <p className="text-sm text-slate-500 leading-relaxed mb-5 line-clamp-3">
                  {sector.subtitle}
                </p>
                <div className="flex items-center gap-3 flex-wrap mb-4">
                  {sector.stats.slice(0, 2).map((stat) => (
                    <span
                      key={stat.label}
                      className={`text-xs font-semibold ${colors.tag} ${colors.bg} px-2.5 py-1 rounded-full`}
                    >
                      {stat.value} {stat.label}
                    </span>
                  ))}
                </div>
                <span
                  className={`inline-flex items-center gap-1.5 text-sm font-semibold ${colors.arrow}`}
                >
                  Scopri di piu
                  <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
};
